import { InfiniteData } from "@tanstack/react-query";
import camelcaseKeys from "src/utils/camelCaseKeys";
import formatDate from "src/utils/formatDate";

const adaptAdminForms = (
	data: InfiniteData<CMSPaginatedData<IAdminObservationForm>>
): InfiniteData<CMSPaginatedData<IAdminObservationForm>> => {
	const { pageParams, pages } = data;

	const forms: CMSPaginatedData<IAdminObservationForm>[] = pages.map((page) => {
		return {
			count: page.count,
			next: page.next,
			previous: page.previous,
			results: page.results.map((result: IAdminObservationForm) => {
				return {
					...camelcaseKeys(result),
					updatedBy: result.updated_by?.name,
					createdAt: formatDate(result.created_at),
					updatedAt: formatDate(result.updated_at),
				};
			}),
		};
	});

	return {
		pageParams,
		pages: forms,
	};
};

export default adaptAdminForms;
